export default __webpack_public_path__ + "media/src/assets/images/lock_blue-56641c04ef19e03769d86d598c278d9a.png";